module.exports = __webpack_public_path__ + "img/product-shot_06.e12617da.jpg";